import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

function homeForRole(role) {
  if (role === "admin") return "/admin/issues";
  if (role === "member") return "/member";
  return "/resident";
}

export function ProtectedRoute({ children, requiredRole, allowedRoles }) {
  const { session, profile, loading, error } = useAuth();

  if (loading) return <div className="screen"><p>Loading…</p></div>;
  if (error) return <div className="screen"><div className="error-block" role="alert">{error}</div></div>;
  if (!session) return <Navigate to="/login" replace />;
  if (!profile) return <div className="screen"><p>Loading profile…</p></div>;
  if (!profile.active) return <Navigate to="/login" replace />;

  const permittedRoles = allowedRoles || (requiredRole ? [requiredRole] : []);
  if (permittedRoles.length && !permittedRoles.includes(profile.role)) {
    return <Navigate to={homeForRole(profile.role)} replace />;
  }

  return children;
}
